var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarcode(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.205,
    height: 16.164,
    viewBox: "0 0 20.205 16.164",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#343434;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-987.617 -430)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(989.3 432.021)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.674,
    height: 11.113
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(990.984 432.021)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1.01,
    height: 9.429
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(993.005 432.021)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.674,
    height: 9.429
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(994.352 432.021)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1.01,
    height: 9.429
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(996.035 432.021)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.674,
    height: 9.429
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(987.617 430)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M.337,51.2A.318.318,0,0,0,0,51.537v1.684H.674V51.874H2.021V51.2Z",
    transform: "translate(0 -51.2)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(997.383 432.021)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.674,
    height: 11.113
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1000.413 432.021)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1.01,
    height: 9.429
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1002.434 432.021)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.674,
    height: 9.429
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1003.781 432.021)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1.01,
    height: 9.429
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1005.465 432.021)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.674,
    height: 11.113
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(987.617 444.144)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M.674,410.947V409.6H0v1.684a.318.318,0,0,0,.337.337H2.021v-.674Z",
    transform: "translate(0 -409.6)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1005.801 444.144)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M462.147,409.6v1.347H460.8v.674h1.684a.318.318,0,0,0,.337-.337V409.6Z",
    transform: "translate(-460.8 -409.6)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1005.801 430)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M462.484,51.2H460.8v.674h1.347v1.347h.674V51.537A.318.318,0,0,0,462.484,51.2Z",
    transform: "translate(-460.8 -51.2)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(990.647 442.123)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.674,
    height: 1.01
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(991.994 442.123)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.674,
    height: 1.01
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(993.341 442.123)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.674,
    height: 1.01
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(994.688 442.123)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.674,
    height: 1.01
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(996.035 442.123)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.674,
    height: 1.01
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(998.73 442.123)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.674,
    height: 1.01
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1000.077 442.123)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.674,
    height: 1.01
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1001.424 442.123)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.674,
    height: 1.01
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1002.771 442.123)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.674,
    height: 1.01
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1004.118 442.123)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.674,
    height: 1.01
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(999.066 432.021)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.674,
    height: 9.429
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcode);
export default __webpack_public_path__ + "static/media/barcode.499e4699f9477d07bd98ca272c000e39.svg";
export { ForwardRef as ReactComponent };